import React, {useEffect, useReducer, useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import { GACntxt } from "../../AllianceApp";




const formReducer = (state: any, event: any) => {
 return {
   ...state,
   [event.name]: event.value
 }
}





function leftOfAt(input: string | undefined): string
{
  if (input === undefined) return "";

  const idx = input.indexOf('@');
  
  return idx === -1 ? input : input.slice(0, idx);
}





const ProfileSetup = () =>
{
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();

    const [userTGAid, setUserTGAID] = useState(null);
    const [userTGAName, setUserTGAName] = useState("");

    const [formData, setFormData] = useReducer(formReducer, {});
    const [submitting, setSubmitting] = useState(false);
    const [dupeUser, setDupeUser] = useState(false);
    const [broken, setBroken] = useState(false);
    const [success, setSuccess] = useState(false);



    const userContext = React.useContext(GACntxt);





    useEffect(() =>
    {

        const setMetaTGAID = async (userID: number) =>
        {
            try
            {
                //New Token required for increased scope
                const accessToken = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: `https://${process.env.REACT_APP_AUTH0_DOMAIN}/api/v2/`,
                      scope: "update:current_user_metadata",
                    },
                });
      
                const patchOptions = 
                {
                    method: 'PATCH',
                    headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify({user_metadata: { tga_id: userID }})
                };

                let userMetaURL = "";

                if(user!)
                {
                    userMetaURL = `https://${process.env.REACT_APP_AUTH0_DOMAIN}/api/v2/users/${user.sub}`;
                }

                await fetch(userMetaURL, patchOptions)
                    .then(response => response.json())
                    .catch((err) => console.log('auth0 error'))
            }
            catch (e: any)
            {
                console.log("profilesetup=>setMetaTGAID: " + e.message);
            }
        };





        const getUserData = async (userAuth0Name: string) =>
        {
            try
            {
                const accessToken = userContext.userAccessToken
      
                const userDataResponse = await fetch(process.env.REACT_APP_REFLEBULA + "/a1/tga/user/byA0/" + userAuth0Name + "", { headers: { Authorization: `Bearer ${accessToken}`,}, });

                const {id, user_name, first_login} = await userDataResponse.json();
                
                setUserTGAID(id);

                if(first_login)  // flip the first_login boolean to false if it is not already false
                {                // and store the user's TGA record ID in their Auth0 profile
                    const postOptions = 
                    {
                        method: 'POST',
                        headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
                        body: JSON.stringify({ first_login: false })
                    };

                    await fetch(process.env.REACT_APP_REFLEBULA + "/a1/tga/user/json/byA0/" + userAuth0Name + "", postOptions)
                        .then(response => response.json())
                        .catch((err) => console.log('reflebula error'))
                    
                    setMetaTGAID(id);
                } 

                setUserTGAName(user_name);  // das_ninja [2026-05-17]: we appear to not actually use this anywhere after it is set
            }
            catch (e: any)
            {
                console.log("profilesetup=>getUserData: " + e.message);
            }
        };




    
        const getUserMetadata = () =>
        {

            setFormData({ name: "auth0_id", value: userContext.userAuth0Id, });
            setFormData({ name: "user_name", value: leftOfAt(userContext.userAuth0UserName), });
            setFormData({ name: "email", value: userContext.userAuth0Email, });
            setFormData({ name: "first_login", value: "FALSE", });

            userContext.userAuth0Id && getUserData(userContext.userAuth0Id);
        };
      



        getUserMetadata();

    }, [userContext]);





    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    {
        // TODO: typescript does not like the line below
        //setFormData({ name: event.currentTarget.name, value: event, });
        setFormData({ name: event.target.name, value: event.target.value, });
    }





    const saveFormData = async() =>
    {
        const accessToken = userContext.userAccessToken;

        const response = await fetch(process.env.REACT_APP_REFLEBULA + "/a1/tga/user/" + userTGAid + "", { headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json'}, method: 'POST', body: JSON.stringify(formData) });

        if (response.status === 200)
        {
            setSuccess(true);

            window.location.href = "/";
        }
        else if (response.status === 400)
        {
            setDupeUser(true);
            setBroken(true);
        }
        else
        {
            setBroken(true);
            console.log(`First profile save attempt failed: ${response.status} ${response.statusText}`);
            //console.log("r: " + resp.keys());
            throw new Error(`First profile save attempt failed: ${response.status} ${response.statusText}`);
        }
    }





    const handleSubmit = async(event: any) =>
    {
        event.preventDefault(); // Prevent default submission
        setDupeUser(false);
        setBroken(false);
        setSuccess(false);
        setSubmitting(true);
        
        try
        {
            await saveFormData();
        }
        catch (e: any)
        {
            console.log(`First profile save failed! ${e.message}`);
        }

        setSubmitting(false);
    }



    if(!isAuthenticated && userTGAName === "")
    {
        //getUserStats();
    }





    if(userContext.userAuth0Id !=="")
    {

        return(
            <React.Fragment>
                <hr />
                
                <div>
                    {submitting &&
                        <p>Attempting to save data to the server...</p>
                    }
                    {broken &&
                        <p>There was a problem saving data to the server.</p>
                    }
                    {success &&
                        <p>Successfully saved data to the server.</p>
                    }
                </div>

                <div>
                    <form onSubmit={handleSubmit}>
                        <fieldset>
                            <label>*User Name:
                                <input style={{ width: "250px", }} type="text" name="user_name" value={formData.user_name || ""} onChange={handleChange} required={true} /> {dupeUser && <span>this user name is currently taken</span>}
                            </label>

                            <br /><br />

                            <label>e-mail:
                                <input style={{ width: "250px", }} type="text" name="email" value={formData.email || ""} onChange={handleChange} disabled /> currently uneditable
                            </label>

                            <br /><br />

                            <label>First:
                                <input type="text" name="first_name" value={formData.first_name || ""} onChange={handleChange} />
                            </label>

                            <br /><br />

                            <label>Last:
                                <input type="text" name="last_name" value={formData.last_name || ""} onChange={handleChange} />
                            </label>
                        </fieldset>

                        <br /><br />

                        <div>
                            <input type="submit" disabled={submitting} />
                            &nbsp; by clicking this "Submit" button, you
                            acknowledge and agree to the Tabletop Gamers
                            Alliance (AKA TGA AKA Gamers Alliance LLC)
                            Online Terms of Service listed below:
                            <ol>
                                <li>
                                    TGA's record of your e-mail address
                                    will:
                                    <p>
                                        a) Be utilized to differentiate
                                        your user profile data from other
                                        users' profile data.
                                    </p>
                                    <p>
                                        b) Be used by TGA to directly
                                        contact you for the purposes that
                                        you have initiated with TGA such as
                                        TGA account issues, TGA event
                                        registrations, and correspondence
                                        that you have directly opted-in to.
                                    </p>
                                    <p>
                                        c) Only be subject to communication
                                        distribution lists or groups that
                                        you directly opt-in to.
                                    </p>
                                    <p>
                                        d) Not be sold nor distributed to
                                        any parties external to TGA.
                                    </p>
                                </li>
                                <li>
                                    Public-facing fields of your user
                                    profile data are socially decent and
                                    not offensive to other TGA Online
                                    users. Any user profile data that TGA
                                    deems in-violation of this clause, will
                                    be subject to sanitization by TGA.  Any
                                    user that repeatedly violates this
                                    clause will be subject to revocation of
                                    their TGA Online account.
                                </li>
                            </ol>
                        </div>
                    </form>
                </div>
            </React.Fragment>
        );
    }
    else
    {
        return(
            <React.Fragment>
                <div>Unable to retrieve user data.</div>
            </React.Fragment>
        );
    }
};
export default ProfileSetup;